export const isGlobal = value => {
    ///TODO
    return value;
};

export const isPais = value => {
    if(!value) return;
    const code = `${value}`;
    const char = code.charAt(0);
    return isRegiao(code) && char == 5 || isDistrito(value) && char > 5;
};

export const isNacional = value => {
    if(!value) return;
    const code = `${value}`;
    const char = code.charAt(0);
    return char < 6;
}

export const isEstrangeiro = value => !isNacional(value);

export const isRegiao = value => {
    if(!value) return;
    const code = `${value}`;
    const char = code.charAt(0);
    return char > 2 && code.endsWith('00000');
};

export const isArquipelago = value => !value || !isIlha(value) ? null : `${value}`.endsWith('00000');

export const isIlha = value => !value ? null : [3,4].includes(parseInt(`${value}`.charAt(0)));

export const isDistrito = value => {
    if(!value) return;
    const code = `${value}`;
    return !isRegiao(code) && code.endsWith('0000');
};

export const isConcelho = value => !value ? null : !isRegiao(value) && !isDistrito(value) && !isFreguesia(value);

export const isConsulado = value => {
    if(!value) return;
    const code = `${value}`;
    const char = code.charAt(0);
    return isFreguesia(code) && char > 5;
};

export const isFreguesia = value => {
    if(!value) return;
    const code = `${value}`;
    return !code.endsWith('00');
};

export const tipo = (value,/*  mundial */) => {
    if(!value) return;
    const foreign = parseInt(`${value}`.charAt(0)) > 5;
    return !isFreguesia(value) ? (!isConcelho(value) ? (!isDistrito(value) ? 'Região' : 'Distrito') : (!foreign ? 'Concelho' : 'País')) : (!foreign ? 'Freguesia' : 'Consulado');
};

export default {
    isGlobal,
    isPais,
    isNacional,
    isEstrangeiro,
    isRegiao,
    isArquipelago,
    isIlha,
    isDistrito,
    isConcelho,
    isConsulado,
    isFreguesia,
    tipo
}